import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UnauthorizedHomePage } from './unauthorized-home-page';

@NgModule({
    declarations: [
        UnauthorizedHomePage,
    ],
    imports: [
        IonicPageModule.forChild(UnauthorizedHomePage),
    ],
})
export class UnauthorizedHomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/unauthorized-home-page/unauthorized-home-page.module.ts